import axios from "axios";

export const create = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'POST',
    url: Routes.abstract_check_list_processes_path({...{...requestParams}, format: "json", _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const update = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'PATCH',
    url: Routes.abstract_check_list_process_path({...{...requestParams}, format: "json", _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const share = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'PATCH',
    url: Routes.share_abstract_check_list_process_path({...{...requestParams}, format: "json", _options: true}),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};
